import { FC, Suspense } from 'react';
import { useIntl } from 'react-intl';
import PrivateRoute from './privateRoutes';

export interface WrapperRouteProps {
  /** document title locale id */
  titleId?: string;
  /** authorization */
  // eslint-disable-next-line react/require-default-props
  element: JSX.Element;
  auth?: boolean;
}

const WrapperRouteComponent: FC<WrapperRouteProps> = ({
  titleId, auth, element,
}) => {
  const { formatMessage } = useIntl();
  if (titleId) {
    document.title = formatMessage({
      id: titleId,
    });
  }

  return (
    <Suspense>
      {auth
        ? <PrivateRoute element={element} />
        : element}
    </Suspense>
  );
};

export default WrapperRouteComponent;
